import {Box, InputBase, styled, Typography} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

const InputBaseStyled = styled(InputBase)(() => ({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& input': {
    textAlign: 'right',
  },
}));

type TemperatureRowProps = {
  label: string;
  message: string;
  temperature: string;
  onChange: (temperature: string) => void;
  error?: boolean;
};

function TemperatureRow(props: TemperatureRowProps) {
  const {label, message, temperature, onChange, error} = props;
  const {t} = useTranslation();

  const [showPlaceholder, setShowPlaceholder] = useState(true);

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const length = event.target.value.length;
    if (length <= 3) {
      onChange(event.target.value);
    }
  }

  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', gap: '16px'}}>
      <Box>
        <Typography
          sx={{fontSize: '20px', fontStyle: 'normal', fontWeight: 500, lineHeight: '28px'}}>
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px',
            color: error ? 'custom.textBrand' : 'custom.textTertiary',
          }}>
          {message}
        </Typography>
      </Box>
      <InputBaseStyled
        sx={{
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '28px',
          color: error ? 'custom.textBrand' : 'custom.textPrimary',
        }}
        type="number"
        placeholder={showPlaceholder ? '0' : ''}
        value={temperature === '0' ? '' : temperature}
        onChange={handleChange}
        onFocus={() => setShowPlaceholder(false)}
        onBlur={() => setShowPlaceholder(true)}
        endAdornment={
          <Typography
            sx={{
              marginLeft: '4px',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '28px',
              color: error ? 'custom.textBrand' : 'custom.textPrimary',
            }}>
            {t('recipe_settings_phases_temperature_celsius_label')}
          </Typography>
        }
      />
    </Box>
  );
}

export default TemperatureRow;
